import { Component } from ".././base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { WyanokeUtil } from "../../util/WyanokeUtil";
import { UrlUtil } from "../../util/UrlUtil";

export class HealioHeader extends Component {
    // tslint:disable-next-line:max-line-length
    public static readonly UnauthenticatedActionEvent = "UnauthenticatedActionEvent";

    private CheckEmailEndpoint = "";

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);

        $("#offcanvasToggle", element).on("click", () => {
            $("#navbarOffcanvas", element).toggleClass("open");
            $("body").toggleClass("mobile-nav-open");
            $(".navbar-toggler-icon", element).toggleClass("d-none");
            $(".navbar-toggler-text", element).toggleClass("d-none");
            $(".global-nav__overlay", element).toggleClass("d-none");
            $(".closebtn", element).toggleClass("d-none");
        });

        $("#searchToggle", element).on("click", () => {
            $("#mobileSearchBar", element).toggleClass("open");
        });

        $(".search-close-btn", element).on("click", () => {
            $("#mobileSearchBar", element).removeClass("open");
        });

        window.addEventListener(HealioHeader.UnauthenticatedActionEvent,
            ev => this.handleRegistrationNeeded(ev));
    }

    public async init(): Promise<void> {
        const globalContext = await WyanokeUtil.loadContext(true);

        if (globalContext && globalContext.sitename && globalContext.itemid) {
            let langroot = this._element.dataset.languageRoot;
            if (!langroot) {
                langroot = globalContext.itemid;
            }
            const suffix = globalContext.sitename + "/" + langroot;
            this.CheckEmailEndpoint = "/utilityapp/json/na/ce/" + suffix;
        }
        const queryStringMap = UrlUtil.getQueryString();
        const loginQuery = queryStringMap.get("login");
        if(loginQuery !== undefined && loginQuery[0] === "1") {
            const loginLink = this._element.getElementsByClassName("link-login")[0].firstChild as HTMLElement;
            if (loginLink){
                const profile = await WyanokeUtil.loadUserProfile(false, false);
                if(!profile || profile.isLoggedIn !== "True"){
                    //There was no easy way to get to the login button as it is loaded dynamically, but ideally this should just call the click function on it
                    WyanokeUtil.logIn();
                }
            }
        }
    }

    private async handleRegistrationNeeded(ev: Event): Promise<void> {
          this.showRegistrationModal(ev, this.CheckEmailEndpoint);
    }

    private showRegistrationModal(ev: Event, endpoint: string ):
    void {
        ev.stopPropagation();
        ev.preventDefault();
        $.ajax({
            type: "GET",
            url: endpoint,
            success(d: string): void {
                if ($(".register-modal").is(":visible")) { return; }
                $("body").append(d);
                if (window.Context && window.Context.sitename &&
                    window.Context.sitename?.indexOf("cme") > -1) {
                    $("*[data-betaVisible='false']").hide();
                    $("*[data-betaVisible='true']").show();
                }
            },
            error(d: Object): void {
                console.log("error returning login modal.");
            }
        });
    }
}

ComponentFactory.registerComponent("HealioHeader", HealioHeader);
